import React from "react";

const TicTacToe: React.FC = () => {
  return (
    <main className="px-6 py-10">
      <h1 className="text-3xl font-bold text-white mb-4">Tic Tac Toe</h1>
      <p className="text-white">Filler Page</p>
    </main>
  );
};

export default TicTacToe;
